import React from "react";
import "./footer.css"
function Footer(){
    return (
        <section id="footer">
            <div className="container p-4">
                <p>@Made By Tushar Bhatia</p>
            </div>
        </section>
    )
}
export default Footer